import React from "react";

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function useFileContents(file: URL): string {
  const [output, setOutput] = React.useState('');

  React.useEffect(() => {
    fetch(file)
      .then(res => res.text())
      .then(text => {
        setOutput(text);
      });
  }, []);

  return output;
}